import { Contact } from "../components/landing/contact";
import { Experience } from "../components/landing/experience";
import { Header } from "../components/landing/header";
import { Nav } from "../components/landing/nav";
import { PersonalProjects } from "../components/landing/personal_projects";
import { Projects } from "../components/landing/selected_projects";
import { TechStack } from "../components/landing/tech_stack";

export const Home = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 overflow-x-hidden font-sans tracking-tight">
      {/* Floating Navigation */}
      <div className="fixed inset-x-0 top-0 z-50 backdrop-blur-md bg-white/90 border-b border-gray-200 shadow-md">
        <Nav />
      </div>

      {/* Hero Section */}
      <section id="nav" className="bg-gradient-to-br from-white via-gray-50 to-gray-100">
        <Header />
      </section>

      {/* Experience Section */}
      <section className="bg-gray-50 border-t border-gray-200">
        <Experience />
      </section>

      {/* Tech Stack */}
      <section className="py-20 bg-white">
        <TechStack />
      </section>

      {/* Projects */}
      <section className="py-20 px-6 bg-gray-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto space-y-28">
          <div className="">
            <Projects />
          </div>

          <div className="border-t border-gray-300">
            <PersonalProjects />
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-24 bg-white shadow-inner shadow-gray-200/20">
        <div className="max-w-4xl mx-auto px-6">
          <Contact />
        </div>
      </section>

      {/* Floating Button (can keep as fun accent) */}
      <div className="fixed bottom-8 right-8 z-30">
        <button onClick={() => scroll()} className="btn btn-circle bg-gray-900 text-white border-none shadow-lg hover:rotate-12 hover:scale-110 transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
        </button>
      </div>
    </div>
  );
};

const scroll = () => {
  document.getElementById("nav")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
